import React from 'react';
import Skeleton from '@/components/common/skeleton';

const Authenticate = () => {
  return <Skeleton active />;
};

export default Authenticate;
